var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"activity"},[(_vm.item)?_c('item-booking-activities',{attrs:{"bookingWorkspaceID":_vm.totemItemBookingWorkspaceID,"data":_vm.item,"filterType":_vm.filterType}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }